import { hideTaskDetailsAction, updateTaskDetailsAction } from 'actions/taskDetails';

import { getTaskDetailsRoute, getRouteAfterRemovingTaskDetails } from 'constants/helper';
import { sendTaskEvent, TASK_EVENTS } from 'constants/mixpanelHelper';

// TODO: change props to object
export const showTaskDetails =
  ({ taskIds = [], onDelete, onUpdate, pageType, viewType, employee, type, useCurrentRoute = true, history }) =>
  (dispatch) => {
    if (pageType) sendTaskEvent({ pageType, eventName: TASK_EVENTS.openedTaskPanel, viewType });

    history.push(
      getTaskDetailsRoute({
        location: history.location,
        ids: taskIds,
        employee,
        type,
        useCurrentRoute,
      })
    );
    return dispatch(updateTaskDetailsAction({ onDelete, onUpdate, employee }));
  };

export const hideTaskDetails =
  ({ history }) =>
  (dispatch) => {
    const route = getRouteAfterRemovingTaskDetails({ location: history.location });
    history.push(route);
    return dispatch(hideTaskDetailsAction());
  };
